function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb234",
  d: "M76 391h40v60H76zM396 391h40v60h-40z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffc96f",
  d: "M5 371h502v40H5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#399349",
  d: "M96 116H56c-11 0-20 9-20 20v215c0 11 9 20 20 20h40c11 0 20-9 20-20V136c0-11-9-20-20-20z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2b6e38",
  d: "M96 116H76v255h20c11 0 20-9 20-20V136c0-11-9-20-20-20z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d84861",
  d: "M256 61h-40c-11 0-20 9-20 20v270c0 11 9 20 20 20h40c11 0 20-9 20-20V81c0-11-9-20-20-20z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c22945",
  d: "M256 61h-20v310h20c11 0 20-9 20-20V81c0-11-9-20-20-20z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3279af",
  d: "M176 371h-40c-11 0-20-9-20-20V81c0-11 9-20 20-20h40c11 0 20 9 20 20v270c0 11-9 20-20 20z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#275e87",
  d: "M176 371h-20V61h20c11 0 20 9 20 20v270c0 11-9 20-20 20z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9cd3fc",
  d: "M116 276h80v40h-80zM116 116h80v40h-80z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#69bdfb",
  d: "M156 276h40v40h-40zM156 116h40v40h-40z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#399349",
  d: "M395.2 369.8l37.6-13.7a20.07 20.07 0 0012-25.6L352.4 76.8a20.07 20.07 0 00-25.6-12l-37.6 13.7a20.07 20.07 0 00-12 25.6l92.3 253.7a20.06 20.06 0 0025.7 12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2b6e38",
  d: "M414 362.9l18.8-6.8a20.07 20.07 0 0012-25.6L352.4 76.8a20.07 20.07 0 00-25.6-12L308 71.6l106 291.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffc96f",
  d: "M343.88 287.4l75.18-27.35 13.68 37.58L357.56 325z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb234",
  d: "M381.45 273.67l37.6-13.68 13.67 37.59-37.59 13.68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffc96f",
  d: "M378.05 147.24l-75.17 27.36-13.68-37.59 75.17-27.36z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb234",
  d: "M378.04 147.2l-37.6 13.69-13.67-37.6 37.59-13.67z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: "236",
  cy: "216",
  fill: "#ffc96f",
  rx: "15",
  ry: "61"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "236",
  cy: "116",
  r: "15",
  fill: "#ffc96f"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "236",
  cy: "316",
  r: "15",
  fill: "#ffc96f"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffb234",
  d: "M236 155v122c8.3 0 15-27.3 15-61s-6.7-61-15-61zm0-54v30c8.3 0 15-6.7 15-15s-6.7-15-15-15zm0 200v30c8.3 0 15-6.7 15-15s-6.7-15-15-15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9cd3fc",
  d: "M61 156h30v175H61z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#69bdfb",
  d: "M76 156h15v175H76z"
})));